import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { useHistory } from "react-router-dom";

import routes from "../../config/routes";
import { withLocalizeStrings } from "../../languages/Localize";
import { useApplicationStateValue } from "../../application/Application";
import { getFormattedNamesFromArray, getFormattedTime, getFormattedDayAndTime } from "../../util/util";
import FavoriteToggleButton, { StyledFavButton } from "../../components/buttons/favorite-toggle-button/FavoriteToggleButton";

export const StyledItemContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
`;

export const StyledTimeLabel = styled(Flex)`
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    justify-content: center;
    align-items: center;
    height: 32px;
    width: 100%;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const StyledSpan = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.light};
`;

const StyledRoom = styled(StyledSpan)`
    margin-left: ${({ theme }) => theme.space[2]}px;
`;

const StyledItem = styled(StyledItemContainer)`
    color: ${({ theme }) => theme.colors.white};
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.white};
    border-left: none;
    border-right: none;
`;

const StyledItemHeaderContainer = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    line-height: 1;
`;

const StyledContainer = styled(Box)`
    display: block;
    width: 100%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
`;

const StyledItemHeader = styled(Box)`
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    width: 70%;
`;

const StyledParticipants = styled(Box)`
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    width: 100%;
    flex-wrap: wrap;
`;

const StyledItemFooter = styled(Flex)`
    width: 100%;
    justify-content: flex-end;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    text-transform: uppercase;
`;

const PanelItem = ({ strings, item, id }) => {
    const { push } = useHistory();
    const {
        appData: { forumSpeakers, forumPanels }
    } = useApplicationStateValue();

    const onClickHandler = id => {
        const impression = forumPanels[id].impression;
        if (impression.comment) {
            push(`${routes.PANELS_IMPRESSION}${id}`, {
                impression: impression,
                id: id,
                code: forumPanels[id].code
            });
        } else {
            push(`${routes.PANELS_DETAILS}${id}`);
        }
    };

    const moderator = ` ${getFormattedNamesFromArray(item.moderators, forumSpeakers, "name")}`;
    const panelists = ` ${getFormattedNamesFromArray(item.speakers, forumSpeakers, "name")}`;
    const footer = `${strings.panel.END} ${getFormattedTime(item.endTime)}, `;
    return (
        <>
            <StyledTimeLabel>{getFormattedDayAndTime(strings.daysOfWeek[new Date(item.startTime).getDay()], item.startTime, "h")}</StyledTimeLabel>
            <StyledItem key={id} sx={{ padding: 3 }}>
                <StyledItemHeaderContainer
                    sx={{
                        paddingLeft: [2, 4],
                        paddingRight: [2, 4],
                        marginBottom: [1, 2]
                    }}>
                    <StyledItemHeader onClick={onClickHandler.bind(null, id)} sx={{ fontSize: [2, 3] }}>
                        {item.label}
                    </StyledItemHeader>
                    <FavoriteToggleButton id={id} renderItem={StyledFavButton} />
                </StyledItemHeaderContainer>
                <StyledContainer onClick={onClickHandler.bind(null, id)}>
                    <StyledParticipants sx={{ paddingLeft: [2, 4], paddingRight: [2, 4], fontSize: [0, 1], marginBottom: [1, 2] }}>
                        {moderator && moderator.trim() && (
                            <>
                                <StyledSpan>{strings.panel.MODERATOR}</StyledSpan>
                                {moderator}
                            </>
                        )}
                    </StyledParticipants>
                    <StyledParticipants sx={{ paddingLeft: [2, 4], paddingRight: [2, 4], fontSize: [0, 1] }}>
                        {panelists && panelists.trim() != "" && (
                            <>
                                <StyledSpan>{strings.panel.PANELISTS}</StyledSpan>
                                {panelists}
                            </>
                        )}
                    </StyledParticipants>
                    <StyledItemFooter
                        sx={{
                            fontSize: [0, 1],
                            paddingLeft: [2, 4],
                            paddingRight: [2, 4],
                            marginTop: [1, 2]
                        }}>
                        {footer}
                        <StyledRoom>{item.room}</StyledRoom>
                    </StyledItemFooter>
                </StyledContainer>
            </StyledItem>
        </>
    );
};

export default withLocalizeStrings(PanelItem);
